import { render, staticRenderFns } from "./EditTabSocial.vue?vue&type=template&id=2dd939e2"
import script from "./EditTabSocial.vue?vue&type=script&lang=js"
export * from "./EditTabSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports